<div class="ir-login-image-wrapper position-absolute top-0 start-0 p-3">
  <img class="ir-login-image" src="../../assets/img/Runtech-logo.png" alt="Logo" width="150" />
</div>
<div class="container d-flex align-items-center justify-content-center vh-100 position-relative overflow-hidden">
  <div class="row justify-content-center w-100">
    <div class="card login-card-wrapper w-100">
      <div class="card-header text-center border-0 bg-transparent pt-4">
        <h3>Login</h3>
      </div>
      <div class="card-body">
        <form [formGroup]="loginFormGroup">
          <div class="form-group mb-3">
            <label for="username">Username</label>
            <input
              class="form-control"
              id="username"
              placeholder="Username"
              formControlName="username"
              required
              [readonly]="loggingIn"
              data-cy="login-username" />
            @if (usernameField?.invalid && usernameField?.touched) {
              <div>
                <small class="text-danger">Invalid username.</small>
              </div>
            }
          </div>

          <div class="form-group mb-3 position-relative">
            <label for="password">Password</label>
            <div class="d-flex align-items-center">
              <input
                class="form-control w-100"
                id="password"
                [type]="passwordFieldType"
                placeholder="Password"
                formControlName="password"
                required
                [readonly]="loggingIn"
                data-cy="login-password" />
              <span class="position-absolute end-0 me-3 mt-3 cursor-pointer eye-icon" (click)="togglePasswordVisibility()">
                <i class="material-icons">{{ passwordFieldType === 'password' ? 'visibility' : 'visibility_off' }}</i>
              </span>
            </div>
            @if (passwordField?.invalid && passwordField?.touched) {
              <div>
                <small class="text-danger">Invalid password.</small>
              </div>
            }
          </div>
          <div class="d-flex justify-content-between align-items-baseline mb-3">
            <div class="form-check">
              <small>
                <input type="checkbox" class="form-check-input" id="rememberMe" formControlName="rememberMe" />
                <label class="form-check-label" for="rememberMe"> Remember me </label>
              </small>
            </div>
            <div>
              <small>
                <a [routerLink]="['/password-recovery']">Forgot password?</a>
              </small>
            </div>
          </div>
          <div class="form-actions">
            <button class="btn btn-primary btn-lg w-100" [disabled]="loggingIn" (click)="logIn()" data-cy="login-btn">
              {{ loggingIn ? 'Logging in...' : 'Login' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
